import {createAsyncThunk} from "@reduxjs/toolkit";
import {
    DocApproverInput,
    NewDocDataInput,
    NewDocumentActorInput,
    PaginationInputAnyFilter,
    RecipientInput
} from "../../../../newShared/GQLTypes";
import {
    approveApproveStageByStageId,
    approveSignStageByStageId,
    fillFillableFieldOnSignStage,
    getFullDocumentWithExecutorForDocs,
    getSharedShortDocumentsPagingDocs,
    getShortDocumentsPagingDocs,
    rejectApproveStageByStageId,
    rejectSignStageByStageId,
    updateFullDocument
} from "../api";
import {addInfoSnack} from "../../../barsEnvironment/snack/store/slice";
import {getActionsData} from "../../../../newShared/redux";
import {AppState} from "../../../../newShared/redux/rootReducer";

export const GetShortDocumentsPagingDocs = createAsyncThunk(
    'Documents/GetShortDocumentsPagingDocs',
    async (pageInfo: PaginationInputAnyFilter, {getState}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        return await getShortDocumentsPagingDocs({pageInfo, workspaceId});
    }
);

export const GetSharedShortDocumentsPagingDocs = createAsyncThunk(
    'Documents/getSharedShortDocumentsPagingDocs',
    async (pageInfo: PaginationInputAnyFilter, {getState}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        return await getSharedShortDocumentsPagingDocs({pageInfo, workspaceId});
    }
);

export const GetFullDocumentWithExecutorForDocs = createAsyncThunk(
    'Documents/getFullDocumentWithExecutorForDocs',
    async (documentId: string, {getState}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        return await getFullDocumentWithExecutorForDocs(documentId, workspaceId);
    }
);

export const RejectSignStageByStageId = createAsyncThunk(
    'Documents/rejectSignStageByStageId',
    async ({stageId, documentId}: {stageId: string, documentId: string}, {getState, dispatch}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        const resp = await rejectSignStageByStageId(stageId, documentId, workspaceId);

        dispatch(addInfoSnack('Reject sign stage success'))
        return resp;
    }
);

export const RejectApproveStageByStageId = createAsyncThunk(
    'Documents/rejectApproveStageByStageId',
    async ({stageId, documentId}: {stageId: string, documentId: string}, {getState, dispatch}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        const resp = await rejectApproveStageByStageId(stageId, documentId, workspaceId);

        dispatch(addInfoSnack('Reject approve stage success'))
        return resp;
    }
);


export const FillFillableFieldOnSignStage = createAsyncThunk(
    'Documents/fillFillableFieldOnSignStage',
    async (data: {stageId: string, values: {fieldId: string, value: string}[], onReject: () => void, documentId: string}, {getState}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        try{
            const resp = await fillFillableFieldOnSignStage(data.stageId, data.values, data.documentId, workspaceId);

            return resp
        }catch (ex){
            data.onReject()
        }
    }
);

export const ApproveSignStageByStageId = createAsyncThunk(
    'Documents/approveSignStageByStageId',
    async ({stageId, documentId}: {stageId: string, documentId: string}, {getState, dispatch}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        const resp = await approveSignStageByStageId(stageId, documentId, workspaceId);

        dispatch(addInfoSnack('Stage completed'))
        return resp;
    }
);

export const ApproveApproveStageByStageId = createAsyncThunk(
    'Documents/approveApproveStageByStageId',
    async ({stageId, documentId}: {stageId: string, documentId: string}, {getState, dispatch}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        const resp = await approveApproveStageByStageId(stageId, documentId, workspaceId);

        dispatch(addInfoSnack('Document approved'))
        return resp;
    }
);

//updateFullDocument
export const UpdateFullDocument = createAsyncThunk(
    'Documents/updateFullDocument',
    async (data: {documentId: string, data: NewDocDataInput, name: string, recipients: RecipientInput[], editors: NewDocumentActorInput[], approvers: DocApproverInput[]}, {getState, dispatch}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        const resp = await updateFullDocument(data.documentId, data.data, data.name, data.recipients, data.editors, data.approvers, workspaceId);

        dispatch(addInfoSnack('Document updated'))
        return resp;
    }
);